import { useLazyPreUploadDocumentCheckQuery } from "../../../../services/clientdocuments";

export type useFileNameCheckOptions = {
    checkFileName: (fileName: string, masterAccountId?: string | null) => Promise<boolean>,
    isLoading: boolean
};

export const useFileNameChecker = () : useFileNameCheckOptions => {
    const [checkQuery, checkQueryResults] = useLazyPreUploadDocumentCheckQuery();

    const handleCheckFileName = (fileName: string, masterAccountId: string | null = null) : Promise<boolean> => new Promise((r, e) => {
        return checkQuery({ masterAccountId, fileName }).unwrap().then(
            (result: any) => r(!result.fileExists),
            (error: any) => e(error) 
        );
    });

    return {
        checkFileName: handleCheckFileName,
        isLoading: checkQueryResults?.isLoading ?? false
    };
};